import { Link } from "react-router-dom";
import styled from "styled-components";
import { device } from "../styled";
import { barberSHopDatas } from "../barberShopDatas";

const Container = styled.div`
  display: flex;
  box-sizing: border-box;
  background-color: #000;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px 15px;
`;

const Logo = styled.img`
  width: 40vw;

  @media ${device.tablet} {
    width: 200px;
  }
`;

const FooterMenuContanier = styled.div`
  margin-bottom: 20px;
  padding-top: 15px;
`;

const NavigationConatiner = styled.nav`
  display: block;
`;

const NavigationUnorderedList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  margin: 0;
  padding: 0;
`;

const MenuItem = styled.li`
  margin: 5px 10px;
  text-transform: uppercase;
  text-decoration: none;
  list-style: none;

  a {
    text-decoration: none;
    color: #fff;
    font-weight: bold;
    font-size: calc(14px + (16 - 14) * ((100vw - 768px) / (1920 - 768)));
  }
`;

const Location = styled.div`
  cursor: pointer;
  gap: 10px;
  border: 2px white solid;
  margin: 10px;
  padding: 0 15px;
  border-radius: 10px;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LocationContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
  padding: 30px 15px;

  a {
    text-decoration: none;
  }

  @media ${device.tablet} {
    justify-content: center;
  }
`;

const CityName = styled.p`
  font-size: 15px;
  margin: 10px 0;
  color: #fff;
  font-weight: bold;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 10px;
`;

const LocationIcon = styled.img`
  height: 20px;
`;

const SocialIcon = styled.img`
  width: 45px;
`;

const LogoContainer = styled.div`
  display: flex;
  width: 90vw;
  align-items: center;
  gap: 10px;
`;

const HalfLineDivider = styled.div`
  width: 100vw;
  height: 2px;
  background-color: #fff;
`;

const SocialIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Footer = () => {
  return (
    <Container>
      <LogoContainer>
        <HalfLineDivider />
        <Link to="/">
          <Logo src={"/logo.png"} />
        </Link>
        <HalfLineDivider />
      </LogoContainer>
      <FooterMenuContanier>
        <NavigationConatiner>
          <NavigationUnorderedList>
            <MenuItem>
              <Link to={"/artist-barbershops"}>Időpontfoglalás</Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/gallery"}>Galéria</Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/connection"}>Kapcsolat</Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/carrier"}>Karrier</Link>
            </MenuItem>
            <MenuItem>
              <Link to={"/about-us"}>Rólunk</Link>
            </MenuItem>
          </NavigationUnorderedList>
        </NavigationConatiner>
      </FooterMenuContanier>
      <SocialIconContainer>
        <a href="https://www.tiktok.com/@kecso__?is_from_webapp=1&sender_device=pc">
          <SocialIcon src={"/tiktok.svg"} />
        </a>
        <a href="https://www.facebook.com/artistmalehairdressing">
          <SocialIcon src={"/fb.svg"} />
        </a>
        <a href="https://google.com">
          <SocialIcon src={"/insta.svg"} />
        </a>
      </SocialIconContainer>

      <LocationContainer>
        <Link to={barberSHopDatas["moson"].link}>
          <Location>
            <CityName>Mosonmagyaróvár</CityName>
            <SocialIcons>
              <LocationIcon src={"/artist-scisor-marker.png"} />
            </SocialIcons>
          </Location>
        </Link>

        <Link to={barberSHopDatas["gyor"].link}>
          <Location>
            <CityName>Győr</CityName>
            <SocialIcons>
              <LocationIcon src={"/artist-scisor-marker.png"} />
            </SocialIcons>
          </Location>
        </Link>

        <Link to={barberSHopDatas["csorna"].link}>
          <Location>
            <CityName>Csorna</CityName>
            <SocialIcons>
              <LocationIcon src={"/artist-scisor-marker.png"} />
            </SocialIcons>
          </Location>
        </Link>

        <Link to={barberSHopDatas["fertod"].link}>
          <Location>
            <CityName>Fertőd</CityName>
            <SocialIcons>
              <LocationIcon src={"/artist-scisor-marker.png"} />
            </SocialIcons>
          </Location>
        </Link>
      </LocationContainer>
    </Container>
  );
};

export default Footer;
